export default function initializeMenu(element) {
  const toggleMenu = element.querySelector('[data-menu-toggle-playmakers]');
  const mainMenuContainer = element.querySelector('[data-main-container-playmakers]');
  const mainMenuClose = element.querySelector('[data-close-menu-playmakers]');
  const backface = element.querySelector('[data-backface-playmakers]');

  const init = () => {
    toggleMenu.addEventListener('click', () => {
      backface.classList.add('!block');
      mainMenuContainer.classList.add('left-slide');
      document.body.classList.add('scroll-lock');
    });

    mainMenuClose.addEventListener('click', (e) => {
      e.preventDefault();
      backface.classList.remove('!block');
      mainMenuContainer.classList.remove('left-slide');
      document.body.classList.remove('scroll-lock');
    });

    backface.addEventListener('click', () => {
      element.querySelector('.show-flex[data-sub-menu]')?.classList.remove('show-flex');
      mainMenuContainer.classList.remove('left-slide');
      backface.classList.remove('!block');
      document.body.classList.remove('scroll-lock');
    });
  };

  init();
}
